import { RouteRecordRaw } from "vue-router";
import { LAYOUT } from "../constants";
import { ManagerType } from "../constants";

export default {
  path: "/enroll",
  redirect: "/enroll/game",
  name: "Enroll",
  component: LAYOUT,
  meta: {
    order: 80,
    roles: [ManagerType.Unit, ManagerType.Single],
    title: "比赛报名",
  },
  children: [
    {
      path: "game",
      name: "EnrollPage",
      component: () => import("@/views/enroll/EnrollPage.vue"),
      meta: {
        title: "比赛报名",
        roles: [ManagerType.Unit, ManagerType.Single],
        keepAlive: true,
        icon: "mdi:swim",
      },
      children: [
        {
          path: ":id",
          name: "EnrollGameDetailPage",
          component: () => import("@/views/enroll/game/GameDetailPage.vue"),
          meta: {
            title: "赛事详情",
            roles: [ManagerType.Unit, ManagerType.Single],
            hideMenu: true,
          },
        },
      ],
    },
  ],
} as RouteRecordRaw;
